import AffixedSidebar from './AffixedSidebar';

export default AffixedSidebar;
